<!--
 * @Description: 
 * @Author: dinghao
 * @Date: 2022-03-28 13:37:26
 * @LastEditTime: 2022-03-28 13:52:20
 * @LastEditors: dinghao
-->
<template>
  <div id="app">
		<router-view  />

  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>
<style>

</style>